import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events/api/events-api.service';

import { fieldsBookingsQueryKeys } from './price-query-keys';



const { getBoothDataById } = EventsApiService();

const getBoothDataByIdQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: fieldsBookingsQueryKeys.list(params),
    queryFn: ({ signal }) => getBoothDataById(params, { config: { signal } }),
    ...options,
});

export const useGetBoothDataById = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getBoothDataByIdQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};



